import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * The rendered width of an element, kept current. For layouts that answer to the room they are
 * given rather than to the window, which parts company with it whenever a drawer opens.
 *
 * @param {import('vue').Ref<HTMLElement|null>} target
 * @returns {import('vue').Ref<number>} width in CSS pixels; 0 until mounted
 */
// eslint-disable-next-line import/prefer-default-export
export function useContainerWidth(target) {
  const width = ref(0);
  let observer = null;

  onMounted(() => {
    if (!target.value) {
      return;
    }
    // The border box both times, so the first reading and every later one measure the same thing.
    width.value = target.value.getBoundingClientRect().width;
    observer = new ResizeObserver(([entry]) => {
      width.value = entry.borderBoxSize?.[0]?.inlineSize ?? entry.target.getBoundingClientRect().width;
    });
    observer.observe(target.value);
  });

  onBeforeUnmount(() => observer?.disconnect());

  return width;
} // useContainerWidth()
